import { qs, listen } from "@fluorescent/dom";

export default function (container) {
  const quantityWrapper = qs(".product__quantity", container);
  if (!quantityWrapper) return;
  const quantityInput = qs("[data-quantity-input]", quantityWrapper);
  const addQuantity = qs("[data-add-quantity]", quantityWrapper);
  const subtractQuanity = qs("[data-subtract-quantity]", quantityWrapper);

  const handleAddQuantity = () => {
    const currentValue = parseInt(quantityInput.value);

    let newValue = currentValue + 1;

    if (currentValue < 1) {
      newValue = 1;
    }

    quantityInput.value = newValue;
    quantityInput.dispatchEvent(new Event("change"));
  };

  const handleSubtractQuantity = () => {
    const currentValue = parseInt(quantityInput.value);

    if (currentValue <= 1) return;

    const newValue = currentValue - 1;
    quantityInput.value = newValue;
    quantityInput.dispatchEvent(new Event("change"));
  };

  const events = [
    listen(addQuantity, "click", handleAddQuantity),
    listen(subtractQuanity, "click", handleSubtractQuantity),
  ];

  const unload = () => {
    events.forEach(unsubscribe => unsubscribe());
  };

  return { unload };
}
